import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Bell } from "lucide-react";

// Approval alerts and other pings · polls quietly, no noise when there is nothing.
export default function Notifications({ placement = "down-left" }) {
  const [rows, setRows] = useState([]);
  const [unread, setUnread] = useState(0);
  const [open, setOpen] = useState(false);
  const box = useRef(null);
  const navigate = useNavigate();

  const load = () => api.get("/notifications")
    .then((r) => { setRows(r.data.notifications || []); setUnread(r.data.unread || 0); })
    .catch(() => {});

  useEffect(() => {
    load();
    const id = setInterval(load, 45000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const away = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", away);
    return () => document.removeEventListener("mousedown", away);
  }, []);

  const openTray = async () => {
    setOpen((o) => !o);
    if (!open && unread) { await api.post("/notifications/read", {}).catch(() => {}); setUnread(0); }
  };

  const go = (n) => { setOpen(false); if (n.link) navigate(n.link); };

  return (
    <div className="relative" ref={box}>
      <button data-testid="notif-bell" onClick={openTray} aria-label="Notifications"
        className="relative p-2 hover:bg-surface transition-colors">
        <Bell className="w-4 h-4" />
        {unread > 0 && (
          <span data-testid="notif-unread"
            className="absolute -top-0.5 -right-0.5 min-w-4 h-4 px-1 rounded-full bg-brand-magenta text-white text-[10px] font-bold flex items-center justify-center tabular-nums">
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </button>
      {open && (
        <div data-testid="notif-tray"
          className={`absolute ${placement === "up-right" ? "left-0 bottom-full mb-2" : "right-0 mt-1"} w-80 max-w-[90vw] max-h-96 overflow-y-auto bg-background border border-foreground shadow-2xl z-50`}>
          <div className="px-3 py-2 border-b border-border text-[10px] tracking-[0.2em] uppercase font-bold text-muted-foreground">
            Notifications
          </div>
          {rows.length === 0 && <p className="p-3 text-xs text-muted-foreground">Nothing yet.</p>}
          {rows.map((n) => (
            <button key={n.notif_id} onClick={() => go(n)} data-testid={`notif-${n.notif_id}`}
              className={`w-full text-left p-3 border-b border-border last:border-0 hover:bg-surface transition-colors ${n.read ? "" : "bg-surface/50"}`}>
              <p className="text-sm font-medium leading-snug">{n.title}</p>
              {n.body && <p className="text-[11px] text-muted-foreground mt-1 leading-snug">{n.body}</p>}
              <p className="text-[10px] text-muted-foreground mt-1">{String(n.created_at || "").slice(0, 16).replace("T", " ")}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
